import IconBase from "@/ComponentLibrary/IconBase.vue";

import thumbsUp from "./thumbs-up.svg?inline";
import thumbsDown from "./thumbs-down.svg?inline";

export default IconBase.extend({
  data() {
    return {
      icons: {
        "thumbs-up": thumbsUp,
        "thumbs-down": thumbsDown,
      },
    };
  },
});
